/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Partner_Payout_Row_ToggleInputs */



/**
* | output |
* | --- |
* | "Show customers for {name}" |
*
* @param {Partner_Payout_Row_ToggleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_payout_row_toggle = /** @type {((inputs: Partner_Payout_Row_ToggleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Payout_Row_ToggleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Kunden von ${i?.name} anzeigen`)
	return /** @type {LocalizedString} */ (`Show customers for ${i?.name}`)
});